import { Building2, GraduationCap, type LucideIcon } from 'lucide-react'
import type { Section } from '@/api/types'

/**
 * Display metadata for the two content sections — the single source of truth for
 * their human-facing names. The technical enum values stay `customer` /
 * `internal` (the audience boundary); these are the brand titles shown in the
 * UI. Onboarding = client-facing; ShopView School = internal staff training.
 *
 * `shortLabel` is the compact form the pass-2 design uses in tight chrome (the
 * sidebar section switch is specced as "Onboarding / School" — the full name
 * doesn't fit the 248px rail and wraps).
 */
export const SECTION_META: Record<
  Section,
  { label: string; shortLabel: string; blurb: string; icon: LucideIcon }
> = {
  customer: {
    label: 'Onboarding',
    shortLabel: 'Onboarding',
    blurb:
      'Role-based tracks built from how ShopView’s best shops actually run. Pick a track to start.',
    icon: GraduationCap,
  },
  internal: {
    label: 'ShopView School',
    shortLabel: 'School',
    blurb:
      'For the ShopView team — the reasoning behind every feature plus heavy-duty repair industry context, so you can sell and support with confidence.',
    icon: Building2,
  },
}
